import React from 'react';
import { motion } from 'framer-motion';
import Button from './Button';
import { ArrowRight, ChevronDown } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <div className="relative w-full h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background Image with Cinematic Overlay */}
      <div className="absolute inset-0 z-0 select-none">
        <motion.img 
          initial={{ scale: 1.1, opacity: 0 }}
          animate={{ scale: 1, opacity: 0.5 }}
          transition={{ duration: 2.5, ease: "easeOut" }}
          src="https://images.unsplash.com/photo-1617788138017-80ad40651399?q=80&w=2070&auto=format&fit=crop" 
          alt="Luxury Car Detail" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/20 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl w-full px-6 md:px-12 pt-20">
        <div className="max-w-3xl">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-white/60 text-xs md:text-sm tracking-[0.3em] uppercase mb-8 font-medium pl-1 flex items-center gap-3"
          >
            <span className="w-8 h-px bg-white/30"></span>
            Est. 2024 — Amsterdam
          </motion.h2>
          
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-5xl sm:text-7xl md:text-9xl font-display font-medium text-white leading-[0.85] mb-10 tracking-tighter"
          >
            UNCOMPROMISED<br />
            <span className="text-white/30">PROTECTION</span>
          </motion.h1>
          
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-neutral-400 text-base md:text-xl max-w-lg leading-relaxed mb-12 font-light border-l border-white/20 pl-6"
          >
            Wij conserveren investeringen. Exclusieve detailing en lakbescherming voor wie het verschil ziet.
          </motion.p>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8"
          >
            <Button onClick={() => document.getElementById('selector')?.scrollIntoView({ behavior: 'smooth'})} className="w-full sm:w-auto">
              Start Configuratie
            </Button>
            
            <button 
              onClick={() => document.getElementById('proof')?.scrollIntoView({ behavior: 'smooth'})}
              className="group flex items-center gap-3 text-sm uppercase tracking-widest text-neutral-400 hover:text-white transition-colors py-2 pl-2 sm:pl-0"
            >
              Bekijk Portfolio
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/30 animate-bounce"
      >
        <ChevronDown size={24} />
      </motion.div>
    </div>
  );
};

export default Hero;